import type { ButtonsTypes } from 'estensa-module';
import { IEstensaButtonStatus } from '@se/se.ui.advanced';
import { isEmpty } from 'lodash-es';


/*
 * Enumerato speculare al ButtonsType di AngularJs, sono definiti tutti i pulsanti che possono comparire nella
 * toolbar
 * KEY ACCORPATE:
 *
 * BROKER_ASSOCIATE: 'Associate', => Accorpato a Associate
 * BROKER_CLOSE_MODAL_OPERATIONS: 'Close',  => Accorpato a CLOSE
 * BROKER_REMOVE_ASSOCIATION: 'RemoveAssociation',  => Accorpato a REMOVE_ASSOCIATION
 * BROKER_VALIDATE_ASSOCIATION: 'ValidateAssociation',  => Accorpato a VALIDATE_ASSOCIATION
 * DASHBOARD: 'TitleAdministrativeDashboard', => Accorpato a ADMINISTRATION_DASHBOARD
 * DELETE_ORDER: 'Delete',=> Accorpato a DELETE
 * EDIT_REPORT: 'Modify',   => Accorpato in MODIFY
 * FIRST_LEVEL_SCREENING_CHECK_PENDING: 'CheckPending', => Accorpato a CHECK_PENDING_ACTIVITIES
 * FIRST_LEVEL_SCREENING_NEXT_REPORT: 'Next', => Accorpato a NEXT
 * FIRST_LEVEL_SCREENING_READING: 'Reading',=> Accorpato a READING
 * FIRST_LEVEL_SCREENING_READING_ALL: 'ReadingAll',=> Accorpato a READING_ALL
 * FIRST_LEVEL_SCREENING_REVIEW: 'Review',=> Accorpato a REVIEW
 * FIRST_LEVEL_SCREENING_REVIEW_ALL: 'ReviewAll',=> Accorpato a REVIEW_ALL
 * FIRST_LEVEL_SCREENING_SAVE_OK: 'NegativeOutcome',=> Accorpato a CHECK_PENDING_ACTIVITIES
 * FIRST_LEVEL_SCREENING_SHOW_REPORT: 'RadioViewReport',=> Accorpato a CHECK_PENDING_ACTIVITIES
 * FIRST_LEVEL_SCREENING_UNDO_APPROVE_FOR_OTHER_REVIEWER: 'UndoApprove',=> Accorpato a CHECK_PENDING_ACTIVITIES
 * INSERT_ORDER: 'New',   => Accorpato in NEW
 * MODIFY_ORDER: 'Modify',   => Accorpato in MODIFY
 * MODIFY_ORDER_BUSINESS_UNIT: 'Save',  => Accorpato in SAVE
 * NEW_ORDER: 'New', => Accorpato in NEW
 * NEW_REPORT: 'New', => Accorpato in NEW
 * PATIENT: 'RadiologyFolder',
 * PATIENT_FOLDER: 'RadiologyFolder',
 * PRINT_ACTIVITIES_REPORT: 'Print', => Accorpato in PRINT
 * PRINT_BOOKINGLIST: 'PrintList', => Accorpato in PRINT_LIST
 * PRINT_CASE_HISTORY: 'Print',=> Accorpato in PRINT
 * PRINT_LIST_MAMMOGRAPHIC_SCREENING: 'PrintList', => Accorpato in PRINT_LIST
 * PRINT_MAMMOGRAPHIC_SCREENING: 'Print',=> Accorpato in PRINT
 * PRINT_PREVIEW_ACTIVITIES_REPORT: 'PrintPreview',=> Accorpato in PRINT_PREVIEW
 * PRINT_QUESTION_DATA: 'Print',=> Accorpato in PRINT
 * REPORT_SHOW_IMAGES: 'Images',   => Accorpato in IMAGES
 * SAVE_ADMISSION: 'Save',  => Accorpato in SAVE
 * SAVE_BOOKING: 'Save',  => Accorpato in SAVE
 * SAVE_CASE_HISTORY: 'Save',  => Accorpato in SAVE
 * SAVE_DELIVERY_DETAILS: 'Save',  => Accorpato in SAVE
 * SAVE_EXAM_MODS: 'Save',  => Accorpato in SAVE
 * SAVE_MOD_EXAMINATION: 'Save',  => Accorpato in SAVE
 * SAVE_QUESTION_DATA: 'Save',  => Accorpato in SAVE
 * SAVE_REPORT: 'Save',  => Accorpato in SAVE
 * SAVE_UNLOAD: 'Save',  => Accorpato in SAVE
 * */

export enum ToolbarAction {
    /* PULSANTI DELLA TOOLBAR */
    ACTIVATE_COLLABORATION = 'Avvia la collaborazione',
    ADD_EXAM = 'AddExam',
    ADD_EXAM_TO_REPORT = 'AddExamToReport',
    ADD_EXAM_SELECTION = 'AddExamSelection',
    ADMINISTRATION_DASHBOARD = 'TitleAdministrativeDashboard',
    ADMISSION = 'TitleAdmission',
    ADMISSION_EVASION = 'AdmissionEvasion',
    ANAMNESTIC_DATA_CONSULTATION = 'EditConsultation',
    ANNULMENT = 'AnnulmentReport',
    ANONYMOUS = 'Anonymous',
    APPLY_AND_PRINT = 'AdmissionAndPrint',
    APPLY_NORMAL_VALUES = 'ApplyNormalValues',
    APPROVE_REPORT = 'Approve',
    ASSIGN_EXAM = 'Assign',
    ASSOCIATE = 'Associate',
    ATTACHED_DOCS = 'AttachedDocuments',
    ATTACHED_DOCS_EXAM = 'StudyExternalDocuments',
    ATTACHED_DOCS_PATIENT = 'PatientExternalDocuments',
    AUDIT_LOG_PDF_PRINT = 'ClickAuditLog',
    BACK = 'Back',
    BOOKING_EVASION = 'BookingEvasion',
    BURN = 'Burn',
    /** 89209 */
    CALL_THIRD_PARTIES = 'CallThirdParties', //89209 chiamata per componente terze parti
    CANCEL_ADMISSION = 'UndoAdmission',
    CHECK_PENDING_ACTIVITIES = 'CheckPending',
    CLOSE = 'Close',
    COLLABORATION_TEAMS = 'Collaboration_Button_Title',
    COMMUNICATION = 'Communication',
    COMPILE_NOTE = 'CompileNote',
    COMPLETE_QUESTION_DATA = 'CompleteConsultation',
    CONNECT_PATIENT = 'ConnectPatient',
    COPY = 'Copy',
    CREATE_MEDICAL_PRESCRIPTION = 'CreateMedicalPrescription',
    CREATE_REMOTE_VISIT = 'CreateRemoteVisit',
    DEFINITIVE = 'CARDIO_Definitive',
    DEFINITIVE_AND_PRINT = 'DefinitiveAndPrint',
    DELETE = 'Delete',
    DELETE_EXAMINATION = 'DeleteExamination',
    DISABLE_WEB_DELIVERY = 'DisableWebDelivery',
    DISCONNECT_PATIENT = 'DisconnectPatient',
    // DIRECT_ADMISSION = 'DirectAdmission',//96989
    DUMMY_VNEXT2_TEST_ACTION = 'DummyVnext2TestAction',
    ECG_EXAM_FOLDER = 'ECGFolder',
    EDIT_DELIVERY_DATA = 'EditDeliveryData',
    EDIT_EXAM = 'ModifyExam',
    EDIT_EXAMINATION = 'ModifyExamination',
    ENABLE_WEB_DELIVERY = 'EnableWebDelivery',
    EXAM = 'Exam',
    EXE_CANCEL = 'ExeCancel',
    EXE_SUSPEND = 'ExeSuspend',
    EXE_EXECUTE_AS_LOGGED_USER = 'ExeExecuteAsLoggedUser',
    EXE_EXECUTE_OTHER = 'ExeExecuteOther',
    EXE_UNDO_EXECUTION = 'ExeUndoExecution',
    EXECUTE = 'Execute',
    EXPORT_AS_JSON = 'ExportAsJson',
    EXTERNAL_LINKS = 'ExternalLinks',
    FORCE_VISIT_TYPE = 'ForceVisitType',
    IMAGES = 'Images',
    IMPETO_SURVEY = 'StartEnrollment',
    IMPORT_DICOM_INTO_VNA = 'ImportDicom',
    IMPORT_INTO_VNA = 'ImportIntoVNA',
    IMPORT_NOTDICOM_INTO_VNA = 'ImportNotDicom',
    IMPORT_VISIT = 'ImportVisit',
    MERGE_EXAMS = 'CARDIO_MergeExams',
    MERGE_PATIENT = 'Merge',
    MODIFY = 'Modify',
    MODIFY_BOOKING = 'ModifyBooking',
    MONITORING_KIT_ASSOCIATION = 'MonitoringKitAssociation',
    NEGATIVE_REPORT = 'NegativeReport',
    NEGATIVE_RESULT = 'NegativeOutcome',
    NEW = 'New',
    NEW_EXAM = 'NewExam',
    NEXT = 'Next',
    OBSCURED_DATA = 'ObscuredTitle',
    OPEN = 'Open',
    OPEN_DIARY = 'OpenDiary',
    ORDER_DETAIL = 'View',
    PAST_ECG = 'CARDIO_PastECG',
    PATIENT = 'Patient',
    PATIENT_CARD_AND_ALARMS = 'PatientCardAndAlarms',
    PATIENT_DOCUMENT = 'PatientDocument',
    PATIENT_ENROLMENT = 'PatientEnrolment',
    PERSONAL_FOLDER = ' PersonalFolder',
    PRE_ADMISSION = 'PreAdmission',
    PRINT = 'Print',
    PRINT_DEFINITIVE = 'CARDIO_PrintDefinitive',
    PRINT_LABELS = 'PrintLabel',
    PRINT_LIST = 'PrintList',
    PRINT_MEMORANDUM = 'PrintMemorandum',
    PRINT_MODULES = 'PrintModules',
    PRINT_PREVIEW = 'PrintPreview',
    PRINT_REPORT = 'PrintReport',
    PRINT_SENOLOGY_REPORT = 'PrintEpisode',
    PRINT_SENOLOGY_WORKLIST = 'PrintEpisodeList',
    PRINT_CERTIFICATE = 'PrintCertificate',
    QUESTIONNAIRE = 'ViewQuestionnaire',
    RADIOLOGY_ADMISSION = 'RequestFollowUpTitle',
    RADIOLOGY_FOLDER = 'RadiologyFolder',
    RADIO_READ_ASSIGN = 'RadioReadAssign',
    RADIO_READ_DELETE = 'RadioReadDelete',
    READING = 'Reading',
    READING_ALL = 'ReadingAll',
    REJECTION = 'Reject',
    REMOVE_ASSOCIATION = 'RemoveAssociation',
    REMOVE_EXAM = 'RemoveExam',
    REPORT_SHOW_PDF = 'ViewReportPdf',
    REPORT_WITHOUT_TRACE = 'ReportWithoutTrace',
    REPUBLISH = 'Republish',
    RESEND_EMAIL = 'ReSendEmail',
    REVIEW = 'Review',
    REVIEW_ALL = 'ReviewAll',
    REVOKE_WEB_PUBLICATION = 'RevokeWebPublication',
    SAVE = 'Save',
    SAVE_ADMISSION_AND_PRINT_CUSTOM_TEMPLATE = 'SaveAndPrintCustomTemplate',
    SAVE_ADMISSION_AND_PRINT_LABEL = 'SaveAndPrintLabel',
    SAVE_AND_EXIT = 'SaveAndExit',
    SAVE_AND_GENERATE_MEMORANDUM = 'SaveAndGenerateMemorandum',
    SAVE_MOD_EXAMINATION_ON_SAME_ADMISSION = 'SaveAcceptAndPrintModules',
    SELECT_AND_BURN = 'SelectAndBurn',
    SEND_TO_WORKLIST = 'SendToWorklist',
    SENOLOGY_ANAMNESI = 'SenologyAnamnesi',
    SENOLOGY_AUTO_REPORT = 'AutocomposedReport',
    SENOLOGY_PREDEFINED_REPORT = 'RadioDefaultReports',
    SENOLOGY_PREVIOUS_REPORT = 'PreviousSenologyReports',
    SET_DELIVERABLE = 'SetDeliverable',
    SET_TECHNICIAN = 'SetTechnician',
    SHOW_HIDE_LEFT_AREA = 'ShowHideLeftArea',
    SHOW_HIDE_RIGHT_AREA = 'ShowHideRightArea',
    SHOW_REPORT = 'RadioViewReport',
    SIGN = 'Sign',
    SIGN_AND_PRINT = 'SignAndPrint',
    SIGN_REPORT = 'EventSigned',
    STORE_AVAILABILITY_PREVOUS = 'StoreAvailabilityPrevious',
    SUSPEND = 'SuspendExamination',
    TELECONSULTATION_APPROVE = 'TeleconsultationApprove',
    TELECONSULTATION_SAVE = 'TeleconsultationSave',
    TEST = 'test',
    TOGGLE_TEST = 'toggle test',
    TOGGLE_VISUAL_COMPARISON = 'CARDIO_VisualComparison',
    TOOLBAR_LEFT_SLIDER = 'ToolbarLeftSlider',
    TOOLBAR_RIGHT_SLIDER = 'ToolbarRightSlider',
    UNLOCK_MPS_CD = 'MpsUnlockCD',
    UNDO_APPROVE = 'UndoApprove',
    UNDO_EXECUTION = 'UndoExecution',
    UNDO_MERGE_EXAMS = 'CARDIO_UndoMergeExams',
    UNDO_REJECTION = 'UndoReject',
    UNDO_SUSPENSION = 'UndoSuspension',
    UNDO_VALIDATION = 'UndoValidation',
    UNLOAD = 'UnloadDevices',
    UNLOCK_READ_ONLY = 'CARDIO_UnlockReadOnly',
    VALIDATE_ASSOCIATION = 'ValidateAssociation',
    VISIT_TYPE = 'VisitType',
    PATIENT_REGISTRY = 'MasterData',
    EXAM_MANAGEMENT = 'ExamManagement',
    FEA_AUTH_MANAGEMENT = 'FeaAuthorizationMngt',
    VIEW_ANAMNESTIC_DATA = 'ViewAnamnesticData',
    SEND_TO_REMOTE_REPORTING = 'SendToRemoteReporting',
    CREATE_TELECONSULTATION = 'CreateRemoteConsultation',
    VIEW_IMAGES = 'ViewImages',
    PRINTS = 'Prints',
}

export interface ToolbarActionLabel {
    label: string;
    action: ToolbarAction;
}

export enum PageToToolbarActionType {
    /* AZIONI DALLA PAGINA ALLA TOOLBAR */
    ACTION_TO_TOOLBAR_BUTTONS = 'EnableDisableToolbarButtons',
    ACTION_TO_TOOLBAR_LEFT_SLIDER = 'ActionToToolbarLeftSlider',
    ACTION_TO_TOOLBAR_DISABLE_ALL = 'ActionToToolbarDisableAll',
    ACTION_TO_TOOLBAR_RIGHT_SLIDER = 'ActionToToolbarRightSlider',
}

export interface ToolbarSliderOptions {
    checked: boolean;
    visible: boolean;
    enabled: boolean;
    overlap: boolean;
}

export interface SlidersData {
    initialized: boolean;
    leftSlider: ToolbarSliderOptions;
    rightSlider : ToolbarSliderOptions;
    timeline? : ToolbarTimelineOptions;
}

export interface ToolbarTimelineOptions {
    active : boolean;
    open : boolean;
}

export interface ToolbarButtonData {
    actionType: ToolbarAction;
    label?: string;
    children?: ToolbarButtonData[];
    hasChildren?: boolean;
    isToggle: boolean;
    permission: ButtonsTypes;
    status: IEstensaButtonStatus;
    payload?: any;
    idCardioWebServiceForExtUrlToken?: string;
}

export function mkButtonData(
    actionData: ToolbarAction | ToolbarActionLabel,
    permission: ButtonsTypes,
    status?: IEstensaButtonStatus,
    children?: ToolbarButtonData[],
): ToolbarButtonData {
    let label,
        actionType = null;
    if (typeof actionData === 'object' && actionData !== null) {
        label = actionData.label;
        actionType = actionData.action;
    } else {
        label = actionData;
        actionType = actionData;
    }
    return {
        label,
        actionType,
        permission,
        isToggle: label.startsWith('TOGGLE_'),
        hasChildren: !isEmpty(children),
        children: children ? children.slice() : [],
        status: status ? status : { visible: true, disabled: false, checked: false },
    };
}
